import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { styled } from "baseui";
import { useHistory, useLocation } from "react-router-dom";
import ROUTES_PATH from "../../constants/RouteConstants";
import SubHeader from "../../components/sub-header/SubHeader";
import ListSearchGroup from "../../components/list-search-group/ListSearchGroup";
import ListAsideView from "../../components/list-aside-view/ListAsideView";
import ListSidebarView from "../../components/list-sidebar/ListSidebarView";
import { ACCESS_TYPES, MODELERS_SIDEBAR_ITEMS } from "../../constants/AppEnums";
import * as AppConstants from "../../constants/AppConstants";
import PaginatedSearchList from "../../components/paginated-search-list/PaginatedSearchList";
import { setactiveModeler } from "../../redux/modeler/ModelerActions";
import { fetchModelers, cloneModeler } from "../../redux/modeler/ModelerThunk";
import { useListSearchFilters } from "../../hooks/useListSearchFilters";
import { useFetchItemsList } from "../../hooks/useFetchItemsList";
import { Grid, Cell } from "baseui/layout-grid";
import CloneModal from "../../components/clone-modal/CloneModalComponent";
import * as ModelerActions from "../../redux/modeler/ModelerActions";
import * as GLOBAL_CONSTANTS from "../../constants/GlobalConstants";
import useToaster from "../../hooks/useToaster";
import { resetModelRunState } from "../../redux/model-run/ModelRunActions";

const MainContainer = styled(Grid, ({ $theme }) => ({
  margin: "50px",
  padding: AppConstants.APP_MAIN_PADDING,
  overflowY: "scroll",
}));

const SidebarArea = styled(Cell, ({ $theme }) => ({
  borderRight: "2px solid",
}));

function ModelerListView(props) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [modelers, setModelers] = useState(props.modelersList);
  const [newModelerTitle, setNewModelerTitle] = useState("");
  const [cloneModelerId, setCloneModelerId] = useState("");
  const [cloningInProgress, setCloningInProgress] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  useToaster(props.searchErrorMessage);
  useToaster(props.cloneErrorMessage);
  const {
    viewMode,
    setViewMode,
    setFilterQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    numPages,
  } = useListSearchFilters("list", props.totalModelers);

  const { retryFetch } = useFetchItemsList(currentPage, fetchModelers);

  useEffect(() => {
    setCloningInProgress(props.cloneStatus === GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED);
    if (props.cloneStatus === GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS) {
      setIsCreateModalOpen(false);
      history.push(
        `${ROUTES_PATH.modelerExecute}${props.activeModeler.id}/${ROUTES_PATH.modelerExecuteHome}`
      );
    }
  }, [props.cloneStatus]);

  function onModalCreateClick(newTitle, access) {
    props.onCloneModeler(props.user, cloneModelerId, newTitle, access);
  }

  useEffect(() => {
    props.resetModelRunState();
  }, []);

  useEffect(() => {
    setactiveModeler(props.activeModelerId);
  }, [props.activeModelerId]);

  useEffect(() => {
    setIsLoading(props.isLoadingApps);
  }, [props.isLoadingApps, props.searchError, props.searchErrorMessage]);

  useEffect(() => {
    setModelers(props.modelersList);
  }, [props.modelersList]);

  function handleSelectModeler(modelerId) {
    props.onSetactiveModeler(modelerId);
    history.push(
      `${ROUTES_PATH.modelerExecute}${modelerId}/${ROUTES_PATH.modelerExecuteHome}`
    );
  }
  return (
    <Fragment>
      <CloneModal
        onClose={() => {
          props.resetErrors();
          setIsCreateModalOpen(false);
        }}
        isOpen={isCreateModalOpen}
        headerTitle={"Clone Modeler"}
        onClone={(newTitle, access) => onModalCreateClick(newTitle, access)}
        cloningInProgress={cloningInProgress}
      />
      <SubHeader
        centerChildren={
          <ListSearchGroup
            onTimeKeywordSearchChange={setSearchQuery}
            onRetryFetch={retryFetch}
            onViewModeChange={setViewMode}
          />
        }
      ></SubHeader>
      <MainContainer>
        <SidebarArea span={[1, 2, 2.5]}>
          <ListSidebarView items={MODELERS_SIDEBAR_ITEMS} />
        </SidebarArea>
        <Cell span={[2, 4, 7]}>
          <PaginatedSearchList
            isLoading={isLoading}
            retryFetch={retryFetch}
            items={modelers}
            viewMode={viewMode}
            error={props.searchError}
            errorMessage={props.searchErrorMessage}
            onCreateItem={(modelerId) => {
              setIsCreateModalOpen(true);
              setCloneModelerId(modelerId);
            }}
            onSelectItem={handleSelectModeler}
            onPageChange={(page) => setCurrentPage(page)}
            currentPage={currentPage}
            numPages={numPages}
          />
        </Cell>
        <Cell span={[1, 2, 2.5]}>
          <ListAsideView
            onFilterSelectChange={setFilterQuery}
          ></ListAsideView>
        </Cell>
      </MainContainer>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user.username,
    userId: state.user.id,
    modelersList: state.modeler.modelersList,
    activeModelerId: state.modeler.activeModelerId,
    isLoadingApps: state.modeler.isLoading,
    cloneStatus: state.modeler.cloneStatus,
    totalModelers: state.modeler.total,
    error: state.modeler.error,
    searchError: state.modeler.searchError,
    searchErrorMessage: state.modeler.searchErrorMessage,
    cloneErrorMessage: state.modeler.cloneErrorMessage,
    cloneError: state.modeler.cloneError,
    clonedSuccess: state.modeler.clonedSuccess,
    activeModeler: state.modeler.activeModeler,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFectchModelersByAccess: (access) => {
      dispatch(fetchModelers({ access: { eq: access } }));
    },
    onFectchModelersByUser: (createdBy) => {
      dispatch(
        fetchModelers({
          access: { eq: ACCESS_TYPES.PUBLIC },
          createdBy: { eq: createdBy },
        })
      );
    },
    onSetactiveModeler: (item) => {
      dispatch(setactiveModeler(item));
    },
    onCloneModeler: (user, modelerId, modelerTitle, access) => {
      dispatch(cloneModeler({ user, modelerId, modelerTitle, access }));
    },
    resetErrors: () => {
      dispatch(ModelerActions.resetErrors());
    },
    resetModelRunState: () => {
      dispatch(resetModelRunState());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModelerListView);
